import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/registro'
  },
  {
    path: '/registro/:id',
    name: 'registro',
    component: () => import('../views/Registro.vue')
  },
 
]

const router = new VueRouter({
  routes
})

export default router
